// @flow

/*
* This utility formats value to an integer or decimal number depending on the value
* of passed isDecimal parameter
*
* Valid decimal formats are:
*  - <number(s)>.<number(s)>
*  - .<number(s)>
*
* As far as '.<number(s)>' is not a valid number, the returned formatted value is string
* */

export default ({ value = '', isDecimal = false }: { value: number | string, isDecimal: boolean }): string => {
  let formattedValue = typeof value === 'number' || typeof value === 'string' ? value : ''

  if (isNaN(+formattedValue)) {
    const pointNumberValue = formattedValue.match(/^\.\d*$/g)

    formattedValue = parseFloat(formattedValue) || (pointNumberValue && pointNumberValue[0]) || ''
  }

  if (formattedValue && !isDecimal) {
    formattedValue = parseInt(formattedValue) || ''
  }

  return String(formattedValue)
}
